export default __webpack_public_path__ + "static/media/item-2.6e278ecf.webp";